import React from "react";
 
const ReturnRefundCancellationPolicy = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Return, Refund, and Cancellation Policies</h1>
      <p><strong>Last Updated:</strong> December 04, 2024</p>
      <p>
        Please read the following policies carefully before proceeding with any return, refund, or cancellation requests.
      </p>
 
      <h2>Return Policy</h2>
      <h3>Applicability:</h3>
      <p>
        Niramaya Homeopathy Clinic and Research Centre provides consultation services only and does not sell physical products.  
        Therefore, a return policy is not applicable.
      </p>
 
      <h2>Refund Policy</h2>
      <h3>For Consultation Services:</h3>
      <p>
        Due to the nature of homeopathic consultation services provided by Niramaya Homeopathy, <strong>no refunds</strong> will be entertained once payment is made for any consultation or service.
      </p>
      <h3>Exceptional Cases:</h3>
      <p>Refunds may be issued at the sole discretion of the Company in cases of:</p>
      <ul>
        <li>Double payments made erroneously.</li>
        <li>System errors resulting in payment for undelivered services.</li>
      </ul>
      <p>
        Refunds, if approved, will be processed to the original payment method within <strong>7-10 working days</strong> from the date of approval.
      </p>
 
      <h2>Cancellation Policy</h2>
      <h3>For Appointments or Consultations:</h3>
      <ul>
        <li>Appointment cancellations can be made up to <strong>24 hours prior</strong> to the scheduled time.</li>
        <li>No cancellations will be accepted within 24 hours of the appointment.</li>
        <li>Cancellation requests must be submitted via email or phone using the contact details provided below.</li>
      </ul>
      <h3>For Prepaid Services:</h3>
      <p>
        Cancellation of prepaid consultations will not be allowed once the service has commenced or after the scheduled time.
      </p>
 
      <h2>Shipping & Delivery Policy</h2>
      <p>
        Niramaya Homeopathy Clinic and Research Centre does not ship any physical products as part of its services. All services are provided digitally or on-site at our clinic location.
      </p>
 
      <h2>Order Cancellation by the Company</h2>
      <p>
        Niramaya Homeopathy reserves the right to cancel any consultation or service due to unforeseen circumstances such as unavailability of practitioners or technical issues.  
        In such cases, the payment made for the canceled service will be refunded to the original payment method within <strong>7-10 working days</strong>.
      </p>
 
      <h2>Contact Us</h2>
      <p>If you have any questions or concerns regarding the Return, Refund, or Cancellation Policies, please contact us at:</p>
      <ul>
        <li><strong>Company Name:</strong> Niramaya Homeopathy Clinic and Research Centre</li>
        <li><strong>Address:</strong> 0230-B Civil Lines 2, Near DIG Bungalow, Bilandpur, Gorakhpur</li>
        <li><strong>Phone Number:</strong> +919236185711</li>
        <li><strong>Email Address:</strong> niramayaforyou@gmail.com</li>
      </ul>
    </div>
  );
};
 
export default ReturnRefundCancellationPolicy;